// Route configuration for App.js to reduce cyclomatic complexity
import LandingPage from "../pages/LandingPage";
import Dashboard from "../pages/Dashboard";
import SymptomChecker from "../pages/SymptomChecker";
import Appointments from "../pages/Appointments";
import HealthData from "../pages/HealthData";
import DietTracker from "../pages/DietTracker";
import MedicalReports from "../pages/MedicalReports";
import Telemedicine from "../pages/Telemedicine";
import PatientManagement from "../pages/PatientManagement";
import AddEditPatient from "../pages/AddEditPatient";
import PatientDetail from "../pages/PatientDetail";
import Chatbot from "../pages/Chatbot";
import PredictiveHealth from "../pages/PredictiveHealth";
import SkinScanner from "../pages/SkinScanner";
import AIHealthFeatures from "../pages/AIHealthFeatures";
import MedicationReminder from "../pages/MedicationReminder";
import AIPrescription from "../pages/AIPrescription";
import VisitorAnalytics from "../pages/VisitorAnalytics";
import ChronicDiseaseHub from "../pages/ChronicDiseaseHub";
import RetinalScan from "../pages/RetinalScan";
import VoiceBiomarker from "../pages/VoiceBiomarker";
import EmergencyProfile from "../pages/EmergencyProfile";
import MealAnalyzer from "../pages/MealAnalyzer";
import WearablesHub from "../pages/WearablesHub";
import TerraWearables from "../pages/TerraWearables";
import GeneticHealthMap from "../pages/GeneticHealthMap";
import HealthBet from "../pages/HealthBet";
import PremiumHealthPredictions from "../pages/PremiumHealthPredictions";
import ABDMIntegration from "../pages/ABDMIntegration";
import SOSEmergency from "../pages/SOSEmergency";
import LabComparator from "../pages/LabComparator";
import YogaExercise from "../pages/YogaExercise";
import DiagnosticsBooking from "../pages/DiagnosticsBooking";
import MenuSettings from "../pages/MenuSettings";
import InsuranceHub from "../pages/InsuranceHub";
import HIPAACompliance from "../pages/HIPAACompliance";
import VaccinationTracker from "../pages/VaccinationTracker";
import FamilyDashboard from "../pages/FamilyDashboard";
import ElderlyCare from "../pages/ElderlyCare";
import PregnancyTracker from "../pages/PregnancyTracker";
import EmergencySOS from "../pages/EmergencySOS";
import MedicineScanner from "../pages/MedicineScanner";
import NearbyClinics from "../pages/NearbyClinics";
import FirstAidGuide from "../pages/FirstAidGuide";
import FoodPriceCompare from "../pages/FoodPriceCompare";

// Protected routes - require authentication
export const protectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/symptom-checker", component: SymptomChecker },
  { path: "/appointments", component: Appointments },
  { path: "/health-data", component: HealthData },
  { path: "/diet-tracker", component: DietTracker },
  { path: "/medications", component: MedicationReminder },
  { path: "/ai-prescription", component: AIPrescription },
  { path: "/reports", component: MedicalReports },
  { path: "/telemedicine/:appointmentId", component: Telemedicine },
  { path: "/patients", component: PatientManagement },
  { path: "/patients/add", component: AddEditPatient },
  { path: "/patients/:patientId", component: PatientDetail },
  { path: "/patients/:patientId/edit", component: AddEditPatient },
  { path: "/chatbot", component: Chatbot },
  { path: "/predictive-health", component: PredictiveHealth },
  { path: "/skin-scanner", component: SkinScanner },
  { path: "/ai-features", component: AIHealthFeatures },
  { path: "/chronic-disease", component: ChronicDiseaseHub },
  { path: "/retinal-scan", component: RetinalScan },
  { path: "/voice-biomarker", component: VoiceBiomarker },
  { path: "/emergency-profile", component: EmergencyProfile },
  { path: "/meal-analyzer", component: MealAnalyzer },
  { path: "/wearables", component: TerraWearables },
  { path: "/wearables/success", component: TerraWearables },
  { path: "/wearables/failure", component: TerraWearables },
  { path: "/wearables-legacy", component: WearablesHub },
  { path: "/genetic-health", component: GeneticHealthMap },
  { path: "/healthbet", component: HealthBet },
  { path: "/health-predictions", component: PremiumHealthPredictions },
  { path: "/insurance", component: InsuranceHub },
  { path: "/hipaa", component: HIPAACompliance },
  { path: "/vaccination", component: VaccinationTracker },
  { path: "/family", component: FamilyDashboard },
  { path: "/elderly-care", component: ElderlyCare },
  { path: "/pregnancy", component: PregnancyTracker },
  { path: "/emergency-sos", component: EmergencySOS },
  { path: "/medicine-scanner", component: MedicineScanner },
  { path: "/nearby-clinics", component: NearbyClinics },
  { path: "/first-aid", component: FirstAidGuide },
  { path: "/abdm", component: ABDMIntegration },
  { path: "/sos-emergency", component: SOSEmergency },
  { path: "/lab-comparator", component: LabComparator },
  { path: "/yoga-exercise", component: YogaExercise },
  { path: "/diagnostics", component: DiagnosticsBooking },
];

// Admin-only routes
export const adminRoutes = [
  { path: "/analytics", component: VisitorAnalytics },
  { path: "/admin/menu-settings", component: MenuSettings },
];

// Public component export
export { LandingPage };
